import * as stylex from '@stylexjs/stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';

// The filter/action bar that sits between a PageHeader and a table (R-304).
//
// It exists because `Input`/`Select`/`Search` all carry `width: 100%` — correct
// inside a `Field`, where the field owns the width, and wrong in a flex bar,
// where `100%` resolves against the whole bar. Dropped straight into a flex row
// a `Select` therefore demands the entire width and `flex-wrap` pushes every
// sibling onto its own line: the Requests screen rendered its search, its state
// filter and its "Mine only" switch as THREE stacked rows from a style that
// reads `display: flex`.
//
// Assets had already hit this and worked around it locally
// (`toolbarSelect: { width: '240px', flexShrink: 0 }`), which is why its five
// filters sat on one line — and why its search then wrapped alone to the next.
// Same bug, opposite symptom, two different local fixes. Hence one owner.
//
// ⚠ Every item has a FIXED width and the bar is left-packed — no item stretches
// into the bar's slack. That was tried first and it is wrong here: `ui/Search`
// caps its own wrapper at 320px, so a stretching slot does not widen the input,
// it just moves the dead space from the end of the bar to the inside of the item
// (measured: an 804px slot holding a 320px field). Filters read as a row of
// controls, not as a stretched form.
export const styles = {
  bar: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1mnnc3i",
    k1K539: "x1cg34oi",
    $$css: true
  },
  item: {
    kzQI83: "x1c4vz4f",
    kmuXW: "x2lah0s",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  auto: {
    kCS8Yb: "xdl72j9",
    kzqmXN: "x14atkfc",
    $$css: true
  },
  sm: {
    kCS8Yb: "xykynuu",
    kzqmXN: "xq1dxzn",
    $$css: true
  },
  md: {
    kCS8Yb: "xjpgo6f",
    kzqmXN: "x1oysuqx",
    $$css: true
  },
  lg: {
    kCS8Yb: "x1gc7yrn",
    kzqmXN: "x1hfn5x7",
    $$css: true
  },
  xl: {
    kCS8Yb: "x1a4bs9z",
    kzqmXN: "x1m258z3",
    $$css: true
  },
  end: {
    koQZXg: "x8x9d4c",
    $$css: true
  }
};